'use client'
import { LicenseInfo } from '@mui/x-license-pro'
import { getEnvVariable } from '@/app/service/getenvService'

import { useEffect } from 'react';

export default function MuiXLicense() {
	useEffect(() => {
		const setLicense = async () => {
			const licenseKey = await getEnvVariable('NEXT_PUBLIC_MUI_LICENSE_KEY');
			if (licenseKey) {
				LicenseInfo.setLicenseKey(licenseKey);
			} else {
				console.error('NEXT_PUBLIC_MUI_LICENSE_KEY is not defined or invalid.');
			}
		};
		setLicense();
	}, []);

	return null;
}


// No additional code is needed at this placeholder for the license key to work.
// However, ensure that `NEXT_PUBLIC_MUI_LICENSE_KEY` is correctly set in your `.env` file.
// Example:
// NEXT_PUBLIC_MUI_LICENSE_KEY=your-license-key

// Also, ensure that `NEXT_PUBLIC_MUI_LICENSE_KEY` is prefixed with `NEXT_PUBLIC_` 
// so it can be exposed to the client-side in a Next.js application.